
import React, { ReactNode } from "react";
import { Button } from "@/components/ui/button";
import { ChevronDown, ChevronUp } from "lucide-react";
import { 
  Collapsible, 
  CollapsibleContent, 
  CollapsibleTrigger 
} from "@/components/ui/collapsible";
import { motion } from "framer-motion";

interface CollapsibleSectionProps {
  title: string;
  icon: ReactNode;
  isCollapsed: boolean;
  onToggle: () => void;
  children: ReactNode;
  className?: string;
}

const CollapsibleSection = ({
  title,
  icon,
  isCollapsed,
  onToggle,
  children,
  className = "mb-6"
}: CollapsibleSectionProps) => {
  return (
    <Collapsible open={!isCollapsed} onOpenChange={onToggle} className={className}>
      <div className="flex justify-between items-center mb-4">
        <div className="flex items-center gap-2">
          {icon}
          <h2 className="text-lg md:text-xl font-semibold text-golf-700">{title}</h2>
        </div>
        <CollapsibleTrigger asChild>
          <Button variant="ghost" size="sm" className="h-8 w-8 p-0">
            {isCollapsed ? <ChevronDown /> : <ChevronUp />}
          </Button>
        </CollapsibleTrigger>
      </div>
      <CollapsibleContent>
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3 }}
        >
          {children}
        </motion.div>
      </CollapsibleContent>
    </Collapsible>
  );
};

export default CollapsibleSection;
